import Cookies from 'js-cookie'
var uuid = require('node-uuid')

const TokenKey = 'website-token'
const TermialCodeKey = 'terminalCode'
const MidKey = 'mid'

// export function setToken(token){
  
//   return sessionStorage.setItem(TokenKey,token);//设置数据
// }

// export function getToken(){
//   return sessionStorage.getItem(TokenKey);//取出数据
// }

export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  //return Cookies.set(TokenKey, token,{ expires: new Date(new Date().valueOf()+600000) }) //10分钟过期时间
  return Cookies.set(TokenKey, token) //10分钟过期时间
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}

export function setTerminalCode(terminalCode) {
  return Cookies.set(TermialCodeKey, terminalCode)
}

export function getTerminalCode() {
  let code= Cookies.get(TermialCodeKey)||uuid.v1();
  setTerminalCode(code);
  return code;
}

export function getMid() {
  return Cookies.get(MidKey)
}

export function removeMid() {
  return Cookies.remove(MidKey)
}

export function setMid(mid) {
  return Cookies.set(MidKey, mid) //10分钟过期时间
}

const authInfoKey = 'authInfo'
export function setAuthInfo(authInfo) {
  return Cookies.set(authInfoKey,authInfo)
}
export function getAuthInfo() {
  if(Cookies.get(authInfoKey) !== undefined){
    return JSON.parse(Cookies.get(authInfoKey))
  }
}
export function removeAuthInfo() {
  return Cookies.remove(authInfoKey)
}

// userInfo
const userInfoKey = 'userInfo'
export function setUserInfo(userInfo) {
  return Cookies.set(userInfoKey,userInfo)
}
export function getUserInfo() {
  if(Cookies.get(userInfoKey) !== undefined){
    return JSON.parse(Cookies.get(userInfoKey))
  }
}
export function removeUserInfo() {
  return Cookies.remove(userInfoKey)
}

// obligeeList
const obligeeListKey = 'obligeeList'
export function setObligeeList(obligeeList) {
  // Cookie 只能存储字符串
  // console.log(encodeURIComponent(JSON.stringify(obligeeList)).length);//浏览器对单个 Cookie 有 4KB（4096字节） 限制，如果 obligeeList 数据太大，Cookies.set() 可能会静默失败。
  // Cookies.set(obligeeListKey,encodeURIComponent(JSON.stringify(obligeeList)))
  //这里超过了4096
  //改用 localStorage 储存
  localStorage.setItem(obligeeListKey, JSON.stringify(obligeeList));
}
export function getObligeeList() {
  // if(Cookies.get(obligeeListKey) !== undefined){
  //   return JSON.parse(decodeURIComponent(Cookies.get(obligeeListKey)))
  // }
  // console.log('56565656565',localStorage.getItem(obligeeListKey));
  if(localStorage.getItem(obligeeListKey) !== undefined){
    return JSON.parse(localStorage.getItem(obligeeListKey))
  }
}
export function removeObligeeList() {
  // return Cookies.remove(obligeeListKey)
  return localStorage.removeItem(obligeeListKey)
}

// vipInfo
const vipInfoKey = 'vipInfo'
export function setVipInfo(vipInfo) {
  return Cookies.set(vipInfoKey,vipInfo)
}
export function getVipInfo() {
  if(Cookies.get(vipInfoKey) !== undefined){
    return JSON.parse(Cookies.get(vipInfoKey))
  }
}
export function removeVipInfo() {
  return Cookies.remove(vipInfoKey)
}
